import * as stylex from "@stylexjs/stylex";
import { ChevronRight } from "lucide-react";
import type { Ref } from "react";
import { copy } from "@/copy";
import "@/theme/tokens.stylex";
import { colors, motion, radii, shadows } from "@/theme/tokens.stylex";
import { Icon } from "@/ui/Icon";
import { press } from "@/ui/press";
const styles = {
  grip: {
    kVAEAm: "xixxii4",
    k87sOh: "xwa60dl",
    kbCHJM: "xu96u03",
    kY2c9j: "x1u8a7rm",
    kzqmXN: "x187nhsf",
    kZKoxP: "x16d3s56",
    keoZOQ: "x1jxqc7s",
    kmVPX3: "x1717udv",
    kMzoRj: "xc342km",
    kWkggS: "xjbqb8w",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1nhvcw1",
    kkrTdU: "x1ypdohk",
    k1ekBW: "x11xpdln",
    kIyJzY: "x1bpocu2",
    kAMwcw: "x1em5f5i",
    $$css: true
  },
  off: {
    k1xSpc: "x1s85apg",
    $$css: true
  }
};
type SidebarGripProps = {
  shown: boolean;
  small?: boolean;
  onShow: () => void;
  ref?: Ref<HTMLButtonElement>;
};
export function SidebarGrip({
  shown,
  small = false,
  onShow,
  ref
}: SidebarGripProps) {
  return <button ref={ref} type="button" hidden={!shown} aria-label={small ? copy.nav.openMenu : copy.nav.showSidebar} aria-expanded={false} onClick={onShow} {...stylex.props(styles.grip, press.scale, !shown && styles.off)}>
      <span {...{
      0: {
        className: "x78zum5 x6s0dn4 xl56j7k x14qfxbe x19swzb4 x1ohsrpc x90zdag xh540kj x1a11ngh x1i34sqz"
      },
      1: {
        className: "x78zum5 x6s0dn4 xl56j7k x1ohsrpc x90zdag xh540kj x1a11ngh x1i34sqz xvy4d1p xjp8j0k"
      }
    }[!!small << 0]}>
        <Icon icon={ChevronRight} size={22} strokeWidth={2} />
      </span>
    </button>;
}